<template lang="pug">
.accordion__list(v-if="localData")
	.accordion__list-item(
		v-for="(item, index) in localData.content"
		:key="localData.content.id"
		:class="{ 'show': item.isOpen }"
		@click="openItem(item.id)"
	)
		.accordion__list-item-content
			.accordion__list-item-index(v-if="localData.content.length > 1") {{ index + 1 }}
			template(v-if="item.sectionLink")
				h3.accordion__list-item-title(:class="{ 'accordion__list-item-title--wide': localData.content.length === 1 }")
					a.accordion__title-link(:href="item.sectionLink" @click.stop) {{ item.title }}
			template(v-else)
				h3.accordion__list-item-title(:class="{ 'accordion__list-item-title--wide': localData.content.length === 1 }") {{ item.title }}

			v-collapse(:open="item.isOpen")
				.accordion__list-text(:class="{ 'show': item.isOpen }" @click.stop)
					.text-guide.text-guide--sm(v-html="item.body")
				template(v-if="data.type === 'slider'")
					.accordion__list-item-slider(v-if="item.children && item.children.length" :class="{ 'list-item--small': item.children.length <= 4 }" @click.stop)
						v-hero-slider(:data-source="{ 'slides': item.children }" :options="optionsSlider" accordionChild @open-modal="openModal")
				template(v-else-if="localData.type === 'gallery' && item.gallery")
					.accordion__list-item-gallery(v-if="item.gallery.items && item.gallery.items.length" @click.stop)
						.gallery__wrapper(ref="scrollBlock")
							.visible-f.hidden-sm.gallery__preview-content
								.gallery__cards-container
									template(v-for="(image, ind) in item.gallery.items" :key="image.id")
										template(v-if="ind === 0 || ind % 3 === 0")
											.gallery__card(v-if="image.urlPrev || image.src" @click="openSlider(item.gallery, item.id, ind)")
												img.gallery__card-image(v-if="image.urlPrev || image.src" :src="image.urlPrev || image.src" :alt="image.alt")
												.gallery__card-bg-block
													.svg--gallery(v-if="localData.galleryIcon")
														img.svg-icon.svg-icon--full(:src="localData.galleryIcon")
								.gallery__cards-container.gallery__cards-container--up
									template(v-for="(image, ind) in item.gallery.items" :key="image.id")
										template(v-if="ind === 1 || (ind - 1) % 3 === 0")
											.gallery__card(v-if="image.urlPrev || image.src" @click="openSlider(item.gallery, item.id, ind)")
												img.gallery__card-image(v-if="image.urlPrev || image.src" :src="image.urlPrev || image.src" :alt="image.alt")
												.gallery__card-bg-block
													.svg--gallery(v-if="localData.galleryIcon")
														img.svg-icon.svg-icon--full(:src="localData.galleryIcon")
								.gallery__cards-container
									template(v-for="(image, ind) in item.gallery.items" :key="image.id")
										template(v-if="ind === 2 || (ind - 2) % 3 === 0")
											.gallery__card(v-if="image.urlPrev || image.src" @click="openSlider(item.gallery, item.id, ind)")
												img.gallery__card-image(v-if="image.urlPrev || image.src" :src="image.urlPrev || image.src" :alt="image.alt")
												.gallery__card-bg-block
													.svg--gallery(v-if="localData.galleryIcon")
														img.svg-icon.svg-icon--full(:src="localData.galleryIcon")

							.hidden.visible-sm-f.gallery__preview-content
								.gallery__cards-container
									template(v-for="(image, ind) in item.gallery.items" :key="image.id")
										template(v-if="ind === 0 || ind % 2 === 0")
											.gallery__card(v-if="image.urlPrev || image.src" @click="openSlider(item.gallery, item.id, ind)")
												img.gallery__card-image(v-if="image.urlPrev || image.src" :src="image.urlPrev || image.src" :alt="image.alt")
												.gallery__card-bg-block
													.svg--gallery(v-if="localData.galleryIcon")
														img.svg-icon.svg-icon--full(:src="localData.galleryIcon")
								.gallery__cards-container.gallery__cards-container--up
									template(v-for="(image, ind) in item.gallery.items" :key="image.id")
										template(v-if="ind === 1 || (ind - 1) % 2 === 0")
											.gallery__card(v-if="image.urlPrev || image.src" @click="openSlider(item.gallery, item.id, ind)")
												img.gallery__card-image(v-if="image.urlPrev || image.src" :src="image.urlPrev || image.src" :alt="image.alt")
												.gallery__card-bg-block
													.svg--gallery(v-if="localData.galleryIcon")
														img.svg-icon.svg-icon--full(:src="localData.galleryIcon")
							v-loader(v-if="!isModalOpened" :loading="loading")
							template(v-if="!loading")
								button.btn.accordion__show-gallery(
									v-if="item.gallery.page.append && item.gallery.page.offset + item.gallery.page.limit <= item.gallery.page.count"
									:class="{ 'btn-more--top': data.type === 'gallery'}"
									@click="showMore(item.id, item.gallery.page, index)"
								) {{ localData.btnText }}

		button.accordion__btn(:class="{ 'show': !item.isOpen }")
			.accordion__btn-icon
				.line
				v-svg-icon.svg-icon.svg-icon--full(icon="plus-icon" :class="{ 'rotate-45': item.isOpen }")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue'
import controller from '../scripts/controller/controller.js'
import breakpoints from '../scripts/breakpoints.js'

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			localData: null,
			optionsSlider: {
				spaceBetween: 40,
				slidesPerView: 'auto',
				watchOverflow: true,
				loop: false,
				grabCursor: true
			},
			currentSliderId: null,
			isModalOpened: false
		}
	},

	mounted() {
		this.updateOptions();
		window.addEventListener('resize', this.updateOptions);
		controller.events.on('load-more-slides', this.triggerShowMore);
		controller.events.on('is-modal-opened', () => {
			this.isModalOpened = true;
		});
		controller.events.on('is-modals-closed', () => {
			this.isModalOpened = false;
		});
	},

	unmounted() {
		window.removeEventListener('resize', this.updateOptions);
	},

	methods: {
		dataSet(data) {
			this.data = data
			if (!this.localData) {
				this.localData = data
			}
			if (this.data && this.data.content) {
				this.localData.content = this.data.content.map((item, index) => {
					if (index === 0) {
						return { ...item, isOpen: true }
					} else {
						return { ...item, isOpen: false }
					}
				})
			}
		},

		openItem(id) {
			this.localData.content.forEach(item => {
				if (item.id === id) {
					item.isOpen = !item.isOpen
				}
			})
		},

		openModal(url) {
			if (url) {
				controller.openModal({
					className: '',
					unlockScroll: 'modal-window',
					url: url
				});
			}
		},

		openSlider({items = null, page = null}, id, initialIndex) {
			if (!items) return;
			let itemInfo = {
				id: id,
				page: {
					append: page.append,
					count: page.count,
					limit: page.limit,
					offset: page.offset
				},
				index: initialIndex
			};
			controller.openModal({
				className: 'modal--gallery',
				content: `
					<v-autoh-slider
						load-next
						:items-count="${page.count}"
						item-info='${JSON.stringify(itemInfo)}'
						:data-source='${JSON.stringify(
							{items}
						)}'
						:initial-index="${initialIndex}"
					>
					</v-autoh-slider>`
			});
			this.currentSliderId = id;
		},

		updateSlider() {
			let sliderData = this.localData;
			controller.updateSlider(sliderData);
		},

		triggerShowMore(e) {
			let id = e.id;
			let page = e.page;
			this.showMore(id, page);
		},

		async showMore(id, page, index) {
			if (id && page) {
				let options = {
					data: {
						...page,
						id: id,
						offset: page.offset + page.limit
					},
					url: this.data.remote,
					delay: true
				}
				await this.dataLoad(options)
				this.localData.content.forEach((item, index) => {
					if (item.id === id) {
						item.gallery.page = this.data.gallery.page
						item.gallery.items = [...this.localData.content[index].gallery.items, ...this.data.gallery.items]
					}
				})
				controller.updateSlider(this.localData.content.find(item => item.id === this.currentSliderId)?.gallery);
			}
			if (typeof index === 'number' && this.$refs.scrollBlock && this.$refs.scrollBlock[index]) {
				this.$refs.scrollBlock[index].scrollTo({
					top: this.$refs.scrollBlock[index].scrollTop + this.$refs.scrollBlock[index].offsetHeight,
					behavior: 'smooth'
				})
			}
		},

		updateOptions() {
			if (window.innerWidth < breakpoints['xs-max']) {
				this.optionsSlider.spaceBetween = 16
			} else {
				this.optionsSlider.spaceBetween = 40
			}
		}
	}
}
</script>